<div class="search-panel ev-card" data-testid="search-panel" data-tutorial-container="search-panel">
  <app-search [failedPlan]="false"></app-search>
</div>
